export interface IRequirements {
  Requirement: IRequirement[];
}
export interface IRequirement {
  Flag: string;
  Group: number;
}

export class RequirementFormValues implements IRequirement {
  Flag: string = "";
  Group: number = 0;

  constructor(Flag?: string, Group?: number) {
    if (Flag) {
      this.Flag = Flag;
    }
    if (Group) {
      this.Group = Group;
    }
    Object.assign(this);
  }
}

export class RequirementsFormValues implements IRequirements {
  Requirement: IRequirement[] = [];

  constructor(RequirementFormValues?: RequirementFormValues[]) {
    if (RequirementFormValues) {
      this.Requirement = RequirementFormValues;
    }
    Object.assign(this);
  }
}
